






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules/decorators'
import { Emit, Prop, PropSync } from 'vue-property-decorator'
import { MessageType } from '@/modules/common/layout/models/types/Messages'
import { Wormhole } from 'portal-vue'
import { Notification } from '@/modules/notification/classes/notification'
import { MessageType as NotifyMessageType } from '@/modules/notification/models/types/message.type'

@Component({
  components: {}
})
export default class BannerMessage extends Vue {
  @PropSync('message') messageSync!: MessageType

  @Prop() type !: string


  get show() {
    return !!this.parsedMessage
  }

  get parsedMessage() {
    return Array.isArray(this.messageSync)
      ? this.messageSync[0]
      : this.messageSync
  }

  get typeSync() {
    return this.type
      ? this.type
      : Array.isArray(this.messageSync)
        ? this.messageSync[1]
        : 'error'
  }

  get style() {
    switch (this.typeSync) {
      case 'error':
        return 'bg-negative'
      case 'success':
        return 'bg-positive'
      default:
        return 'bg-positive'
    }
  }

  get isContained() {
    return Wormhole.hasContentFor('page-header-container')
  }

  get messageType(): NotifyMessageType {
    switch (this.typeSync) {
      case 'error':
        return NotifyMessageType.Error
      case 'success':
        return NotifyMessageType.Success
      default:
        return NotifyMessageType.Success
    }
  }

  get iconType() {
    switch (this.typeSync) {
      case 'error':
        return 'error'
      case 'success':
        return 'check_circle'
      default:
        return 'positive'
    }
  }

  public notify() {
    if (this.show) {
      Notification.show(this.parsedMessage, this.messageType)
    }
  }

  @Emit()
  public close() {
    this.messageSync = ''
  }
}
